/**
 * The class a table row wears when it is history, or a record we stopped working with —
 * an expired or withdrawn posting, an expired or cancelled load, a superseded paper, a row
 * DAT has cancelled, a broker, carrier, unit or agent stood down (TRKC-74).
 *
 * One class and one look for every list, so a dispatcher learns it once: a grey hatch
 * under the whole row and a bar where it starts, never a paler copy of a current row
 * (`index.css` says why).
 */
export function historyRow(isHistory: boolean): string | undefined {
  return isHistory ? 'table__history' : undefined
}
